export default __webpack_public_path__ + "static/media/basicTriangle.139d5828.svg";